import { Box, Container, Divider, Grid, styled } from "@mui/material";
// CUSTOM COMPONENTS
import { Link } from "components/link";
import { FlexBox } from "components/flexbox";
import { Paragraph } from "components/typography";

// styled component
const LinkList = styled(FlexBox)(({
  theme
}) => ({
  a: {
    color: theme.palette.mode === "dark" ? theme.palette.grey[300] : theme.palette.grey[700]
  }
}));
const Footer = () => {
  return <Box pt={12}>
      <Container maxWidth="lg">
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <FlexBox alignItems="center" gap={1} mb={2}>
              <Box alt="logo" width={40} height={40} component="img" src="/static/logo/logo-svg.svg" />

              <Paragraph fontSize={28} fontWeight={600}>
                DreamHouse
              </Paragraph>
            </FlexBox>

          </Grid>

          <Grid item xs={12} sm={4} md={3}>

            <LinkList flexDirection="column" gap={1.5}>
              <Link href="/">Нүүр</Link>
              <Link href="/about-us">Бидний тухай</Link>
            </LinkList>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>

            <LinkList flexDirection="column" gap={1.5}>
              <Link href="/career">Ажлын байр</Link>
              <Link href="/contact-us">Холбоо барих</Link>
            </LinkList>
          </Grid>

          <Grid item xs={12} sm={4} md={2}>

            <LinkList flexDirection="column" gap={1.5}>
              <Link href="/pricing">Үнэ</Link>
              <Link href="/faqs">Заавар</Link>
            </LinkList>
          </Grid>
        </Grid>
      </Container>

      <Divider sx={{
      mt: 12
    }} />

      <Paragraph py={5} textAlign="center" fontSize={16} fontWeight={500}>
        Copyright © 2024{" "}
        <a href="https://tagtaa.solutions/" target="_blank" rel="noreferrer">
          Tagtaa Solution
        </a>
        . All rights reserved
      </Paragraph>
    </Box>;
};
export default Footer;